export const userHistoryConstants = {
    FETCH_STARTED: 'USER_HISTORY_FETCH_STARTED',
    FETCH_COMPLETE: 'USER_HISTORY_FETCH_COMPLETE',
    FETCH_FAILURE: 'USER_HISTORY_FETCH_FAILED',

    ADD_NEW_SUBMISSION: 'USER_HISTORY_NEW_SUBMISSION',

    CLEAR: 'USER_HISTORY_CLEAR',
}